// Trial state machine (pure, testable). The server owns the clock:
// clients never influence these decisions.

import type { SubscriptionStatus } from './types';

export type TrialState = {
  status: SubscriptionStatus;
  trialStartedAt: string | null; // ISO
  trialEndsAt: string | null;
};

export function startTrial(state: {
  now: number; // epoch ms, SERVER time
  trialDays: number;
}): TrialState {
  const trialStartedAt = new Date(state.now).toISOString();
  const trialEndsAt = new Date(state.now + state.trialDays * 24 * 3600 * 1000).toISOString();
  return { status: 'trialing', trialStartedAt, trialEndsAt };
}

/** Days remaining in the trial, floored at 0. */
export function trialDaysLeft(trialEndsAt: string | null, now: number): number {
  if (!trialEndsAt) return 0;
  const ms = new Date(trialEndsAt).getTime() - now;
  return Math.max(0, Math.floor(ms / (24 * 3600 * 1000)));
}

/**
 * Resolves the status of an account without an active subscription.
 * Trial ended (or absent) → expired. Called by a cron/job and after
 * every token issuance so an expired user gets the expired token.
 */
export function resolveNoSubStatus(state: {
  trialEndsAt: string | null;
  now: number;
}): SubscriptionStatus {
  if (state.trialEndsAt && state.now < new Date(state.trialEndsAt).getTime()) {
    return 'trialing';
  }
  return 'expired';
}
